import _ from 'lodash';
import { axiosInstance } from '../helpers';
import { userService } from './user.service';

const getPaymentsReport = (query) => {
    return axiosInstance
        .get(`/payments/report`, { params: query })
        .then(handleResponse)
        .catch(handleRequestError);
};

const createResponseError = (status, data, statusText) => {
    const message = (data && data.message) || statusText || `Request failed with status ${status}`;
    const responseError = new Error(message);
    responseError.status = status;
    responseError.error = message;
    responseError.code = data && data.code;
    responseError.name = (data && data.name) || responseError.name;
    return responseError;
};

const handleResponse = response => {
    if (!response) throw createResponseError(500);
    const data = response.data;
    if (!_.includes([200, 201, 204], response.status)) {
        if (
            response.status === 401
            && response.config
            && !response.config.url.includes('/users/login')
        ) {
            // auto logout if 401 response returned from api
            userService.logout();
            window.location.reload(true);
        }

        throw createResponseError(response.status, data, response.statusText);
    }

    return data;
};

const handleRequestError = error => {
    if (error && error.response) {
        return handleResponse(error.response);
    }
    throw error;
};

export const paymentService = {
    getPaymentsReport,
};
